import { render, staticRenderFns } from "./AddedTags.vue?vue&type=template&id=153a2b56&scoped=true"
import script from "./AddedTags.vue?vue&type=script&lang=js"
export * from "./AddedTags.vue?vue&type=script&lang=js"
import style0 from "./AddedTags.vue?vue&type=style&index=0&id=153a2b56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153a2b56",
  null
  
)

export default component.exports